const ICDF = text =>
  /^[0-2][0-9]{3}-(0[1-9]|1[0-2])-(0[0-9]|1[0-9]|2[0-9]|3[0-1])$/.test(text);

export default ICDF;
